export default __webpack_public_path__ + "static/media/totebag.ddd490c2.png";